import React from "react"
import BtnVerModal from "@components/common/btnVerModal"

const BlockActuacion = ({
  image,
  title,
  subtitle,
  number,
  description,
  to,
  className,
  btnName,
}) => {
  return (
    <div
      className={
        className
          ? `blockActuacion-container  ${className}`
          : "blockActuacion-container"
      }
    >
      <div className="image">
        <img src={image} alt=""></img>
      </div>
      <div className="blockContent">
        <div className="borderA"></div>
        <div className="blockText">
          <div className="content">
            <div className="title">{title}</div>
            <div className="subtitle">{subtitle}</div>
            <div className="number">{number}</div>
            <div className="description">{description}</div>
          
          </div>
          <div className="btnVer">
              <BtnVerModal name={btnName} to={to} />
            </div>
        </div>
        <div className="borderB"></div>
      </div>
    </div>
  )
}

export default BlockActuacion
